var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuotes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 41,
    viewBox: "0 0 53 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 41V29.7221C0 26.3935 0.619204 22.8887 1.85761 19.2077C3.09602 15.5267 4.81818 12.0024 7.0241 8.63467C9.23001 5.26695 11.8229 2.38872 14.8028 0L23.3943 6.22635C21.0336 9.71155 19.0212 13.3534 17.3571 17.1519C15.693 20.9503 14.8609 25.0817 14.8609 29.5458V41H0ZM29.6057 41V29.7221C29.6057 26.3935 30.2249 22.8887 31.4633 19.2077C32.7017 15.5267 34.4239 12.0024 36.6298 8.63467C38.8357 5.26695 41.4286 2.38872 44.4085 0L53 6.22635C50.6393 9.71155 48.6269 13.3534 46.9628 17.1519C45.2986 20.9503 44.4666 25.0817 44.4666 29.5458V41H29.6057Z",
    fill: "#CF072C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.a1677ffd2cb04d9c0a12297c3a1a5edc.svg";
export { ForwardRef as ReactComponent };